import { argon2id } from '@noble/hashes/argon2'
import { randomBytes } from './random'

const SALT_LEN = 16
const KEY_LEN = 32

const ARGON_PARAMS = {
  t: 3,
  m: 65536,
  p: 1,
  dkLen: KEY_LEN,
}

export async function deriveKey(password: string, salt: Uint8Array): Promise<Uint8Array> {
  return argon2id(password, salt, ARGON_PARAMS)
}

export async function generateSalt(): Promise<Uint8Array> {
  return randomBytes(SALT_LEN)
}
